import { useLocalization } from "@/contexts/Localization";
import React, { useEffect, useState } from "react";
import { LanguageSelector } from "../LanguageSelector";

import S from "./Header.style";
import useHeaderData from "./useHeaderData";
import { getImage, GatsbyImage } from "gatsby-plugin-image";
import Menu from './Menu';

type Props = {
  dynamicMenu: {
    list: string;
  }
};

const Header: React.FC<Props> = ({ dynamicMenu }) => {
  const [isOpen, setIsOpen] = useState(false);
  const { language } = useLocalization();
  const data = useHeaderData(language);

  const [toggleDropdown, setToggleDropdown] = useState<[boolean, string]>([false, '']);

  const { languageIcon, logo } = data;

  const [scrollPosition, setScrollPosition] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      setScrollPosition(window.scrollY);
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleOnMouseEnter = (title: string, subLinks: any) => {
    setToggleDropdown([!!subLinks, title]);
  };

  // Prevent body scrolling when menu is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflowY = "hidden";
    } else {
      document.body.style.overflow = "";
      document.body.style.height = "100%";
    }
  }, [isOpen]);

  const logoImage = logo?.gatsbyImage ? getImage(logo.gatsbyImage) : null;

  return (
    <S.Header isOpen={isOpen} scrolled={scrollPosition}>
      <div className="main-inner">
        <S.Wrapper>
          <S.Div>
            <S.LogoLink scrolled={scrollPosition} isOpen={isOpen} href={language == 'sv' ? '/' : (language === 'en' ? '/en' : '/no')}>
              {logoImage && (
                <GatsbyImage
                  className="gatsby-image-logo"
                  image={logoImage}
                  alt={logo.altText}
                  loading="eager"
                />
              )}
            </S.LogoLink>
          </S.Div>

          <S.HeaderLinkContainer onMouseLeave={() => setToggleDropdown([false, ''])}>
            {data.links && data.links.map(({ subLinks, link }, i) => {

              return (
                <S.Div
                  key={i}
                >
                  <S.MenuLink
                    onMouseEnter={(e) => handleOnMouseEnter(link.title, subLinks)}
                    key={i} href={link.url} target={link.target}>
                    {link.title.replace(/\.(.*)/, '')}
                  </S.MenuLink>
                </S.Div>
              )
            }
            )}
            {toggleDropdown[0] &&
              <Menu
                list={dynamicMenu && dynamicMenu.list}
                links={data.links}
                toggleDropdown={toggleDropdown}
                setToggleDropdown={setToggleDropdown}
              />
            }
          </S.HeaderLinkContainer>

          <S.Div>
            {<LanguageSelector
              icon={languageIcon}
              isOpen={isOpen}
              scrolled={scrollPosition}
            />}
            <S.Hamburger onClick={() => setIsOpen(!isOpen)} isOpen={isOpen}>
              <S.HamburgerLine1 isOpen={isOpen} scrolled={scrollPosition} />
              <S.HamburgerLine2 isOpen={isOpen} scrolled={scrollPosition} />
              <S.HamburgerLine3 isOpen={isOpen} scrolled={scrollPosition} />
            </S.Hamburger>

            <S.Container isOpen={isOpen}>
              {data?.links?.map(({ link }, index) => {
                return (
                  <S.LinkContainer className={(typeof window !== "undefined") && window.location.pathname === link?.url ? "active" : ""} key={index}>
                    <S.Link key={index} href={link?.url} target={link?.target}>
                      {link?.title?.replace(/\.(.*)/, '')}
                    </S.Link>
                  </S.LinkContainer>
                );
              })}
              <S.LinkContainer>
                <S.MobileLogin href="https://hub.radargrp.com">
                  {
                    language == 'sv' ?
                      "Logga in" : "Sign in"
                  }
                </S.MobileLogin>
              </S.LinkContainer>
            </S.Container>
            <S.VerticalLine isOpen={isOpen} scrolled={scrollPosition} />
            <S.Login isOpen={isOpen} scrolled={scrollPosition} href="https://hub.radargrp.com">
              {
                language == 'sv' ?
                  "Logga in" : "Sign in"
              }
            </S.Login>
          </S.Div>
        </S.Wrapper>
      </div>
    </S.Header>
  );
};
export default Header;
